import gql from 'graphql-tag';

export default gql`
    mutation($organizationId: String!, $addressId: String!, $comment: String, $alias: String) {
        updateAddressBookRecord(organizationId: $organizationId, addressId: $addressId, comment: $comment, alias: $alias ) {
            code
        }
    }
`;
